import {Paper, PaperProps} from '@mui/material';
import {uiTokens} from './designTokens';

export const Surface = ({sx, ...props}: PaperProps) => (
    <Paper
        elevation={0}
        {...props}
        sx={{
            bgcolor: uiTokens.surface.background,
            border: uiTokens.surface.border,
            borderColor: uiTokens.surface.borderColor,
            borderRadius: uiTokens.surface.radius,
            boxShadow: uiTokens.surface.shadow,
            overflow: 'hidden',
            ...sx,
        }}
    />
);
